function cov_2o0xda7tty() {
  var path = "/app/src/components/snippet-content/snippet-content.tsx";
  var hash = "6aa2c048115ae900fc2f3a3b442f2603171e2b74";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/snippet-content/snippet-content.tsx",
    statementMap: {
      "0": {
        start: {
          line: 15,
          column: 30
        },
        end: {
          line: 35,
          column: 1
        }
      },
      "1": {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 33,
          column: 6
        }
      },
      "2": {
        start: {
          line: 37,
          column: 0
        },
        end: {
          line: 37,
          column: 46
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 16,
            column: 2
          },
          end: {
            line: 16,
            column: 3
          }
        },
        loc: {
          start: {
            line: 16,
            column: 78
          },
          end: {
            line: 34,
            column: 3
          }
        },
        line: 16
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 25,
            column: 13
          },
          end: {
            line: 29,
            column: 13
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 25,
            column: 13
          },
          end: {
            line: 25,
            column: 19
          }
        }, {
          start: {
            line: 26,
            column: 14
          },
          end: {
            line: 28,
            column: 21
          }
        }],
        line: 25
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "6aa2c048115ae900fc2f3a3b442f2603171e2b74"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2o0xda7tty = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2o0xda7tty();
import cn from 'classnames';
import React, { forwardRef } from 'react';
import { Typography } from 'src/components/v2/typography';
import styles from './styles.css';
export var SnippetContent = (cov_2o0xda7tty().s[0]++, /*#__PURE__*/forwardRef(function (_ref, ref) {
  var classNameContent = _ref.classNameContent,
    classNameLink = _ref.classNameLink,
    classNameText = _ref.classNameText,
    link = _ref.link,
    message = _ref.message;
  cov_2o0xda7tty().f[0]++;
  cov_2o0xda7tty().s[1]++;
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.tabbyPromoSnippetContent, classNameContent),
    ref: ref
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption1"
  }, /*#__PURE__*/React.createElement("span", {
    className: cn(styles.tabbyPromoSnippetText, classNameText)
  }, /*#__PURE__*/React.createElement("span", null, message), ' ', (cov_2o0xda7tty().b[0][0]++, !!link) && (cov_2o0xda7tty().b[0][1]++, /*#__PURE__*/React.createElement("span", {
    className: cn(styles.tabbyPromoSnippetLink, classNameLink)
  }, /*#__PURE__*/React.createElement("span", {
    "data-test": "widget-learn-more"
  }, link))))));
}));
cov_2o0xda7tty().s[2]++;
SnippetContent.displayName = 'SnippetContent';